import { render, staticRenderFns } from "./DocVideoDetectionShow.vue?vue&type=template&id=27abcc2a&scoped=true"
import script from "./DocVideoDetectionShow.vue?vue&type=script&lang=js"
export * from "./DocVideoDetectionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abcc2a",
  null
  
)

export default component.exports